import { useState } from "react";
import { faqs } from "@/mocks/topics";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="px-4 md:px-10 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 leading-relaxed">
            第一次来?这里整理了大家最常问的几个问题。如果还有疑问,欢迎写信告诉我们。
          </p>
          <a href="mailto:hello@17.cn" className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors cursor-pointer">
            <i className="ri-mail-send-line"></i>
            联系社区团队
          </a>
        </div>

        <div className="lg:col-span-2 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className={`rounded-lg border transition-colors ${isOpen ? "border-primary-300 bg-background-50" : "border-background-200/80 bg-background-100"}`}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-medium text-sm md:text-base text-foreground-950">{f.q}</span>
                    <i className={`shrink-0 text-lg transition-transform ${isOpen ? "ri-subtract-line text-primary-600 rotate-180" : "ri-add-line text-foreground-500"}`}></i>
                  </button>
                </h3>
                {isOpen && (
                  <div className="px-5 pb-5 -mt-1">
                    <p className="text-sm text-foreground-600 leading-relaxed">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}